/** Reports > Variety Decoding: its filters live in the URL so the view can be bookmarked. */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useAuth } from "@/features/auth/store";
import { spDecodeSearch } from "@/features/reports/sp-decode-api";
import { SpDecodeReportPage } from "@/features/reports/sp-decode-report-page";

export const Route = createFileRoute("/_app/reports/variety-decoding")({
  validateSearch: spDecodeSearch,
  beforeLoad: () => {
    if (!useAuth.getState().can("reports.variety_decoding"))
      throw redirect({ to: "/reports" });
  },
  component: Page,
});

function Page() {
  const s = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <SpDecodeReportPage
      search={s}
      onSearch={(next) =>
        void navigate({ search: (prev) => ({ ...prev, ...next }) })
      }
    />
  );
}
